import React from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";

class OrderTable extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor() {
        super();

        this.getColumns = this.getColumns.bind(this);

        this.reactTable = React.createRef();
    }

    getColumns = () => {
        let result = [];

        const classNameFlexCenter = "";

        result.push({
            Header: "Earliest",
            id: "earliestDate",
            className: classNameFlexCenter,
            Cell: ({ original }) => (
                <div className="mr-1">
                    {moment(original.earliestDate)
                        .format(this.dateFormat)}
                </div>
            ),
        });

        result.push({
            Header: "Latest",
            id: "latestDate",
            className: classNameFlexCenter,
            Cell: ({ original }) => (
                <div className="mr-1">
                    {moment(original.latestDate)
                        .format(this.dateFormat)}
                </div>
            ),
        });


        result.push({
            Header: "Retailer",
            accessor: "retailerName",
            id: "retailerName"
        });
        result.push({
            Header: "Store #",
            accessor: "storeNumber",
            id: "storeNumber"
        });
        result.push({
            Header: "Job #",
            accessor: "jobNumber",
            id: "jobNumber"
        });
        result.push({
            className: classNameFlexCenter,
            Cell: ({ original }) => (
                <button
                    className="btn btn-sm btn-info ml-2"
                    onClick={() => this.props.onView(original.serviceID)}
                >
                    Select
                </button>
            ),
        });


        result = result.map((value) => {
            value.headerClassName = "text-left";
            if (!value.style) {
                value.style = {};
            }
            if (value.style) {
                value.style.display = "flex";
                value.style.alignItems = "center";
                value.style.height = "100%";
            }

            return value;
        });

        return result;
    };

    render() {
        const {
            loading,
            orders,
            orderOptions
        } = this.props;

        return (

            <ReactTable
                data={orders}
                headerClassName="table-header"
                columns={this.getColumns()}
                defaultPageSize={20}
                pageSizeOptions={[20, 50, 100, 500, 1000]}
                pages={Math.ceil(
                    orderOptions.totalFilteredRecords /
                    orderOptions.pageSize
                )}
                resizable
                className="-striped -highlight fix-scrollbar-size"
                loading={loading}
                ref={this.reactTable}
                filterable={false}
                showPagination={true}
                onSortedChange={this.props.handleSortedChange}
                onPageChange={this.props.handlePageChange}
                onPageSizeChange={this.props.handlePageSizeChange}
                handleRefreshPage={this.searchByFilters}
                manual={true}
                defaultSorted={[
                    {
                        id: "earliestDate",
                        desc: false
                    },
                    {
                        id: "latestDate",
                        desc: false
                    }
                ]}
                style={{
                    height: "calc(100vh - 170px)"
                }}
                getNoDataProps={() => ({
                    style: {
                        zIndex: 0
                    }
                })}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(OrderTable);
